import React from "react";
import { Navigate } from "react-router-dom";
import { useSAAuth } from "../../contexts/SAAuthContext";
import { Logo } from "../tabon/Logo";

export function SAProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useSAAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
        <div className="flex flex-col items-center gap-3">
          <Logo size="lg" />
          <div className="text-[#A0A0A0] text-sm animate-pulse">Loading…</div>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  if (adminOnly && user.role !== "Admin") {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-white mb-2">Admin role required</h2>
          <p className="text-[#A0A0A0] text-sm">This action is restricted to Admin users.</p>
        </div>
      </div>
    );
  }
  return children;
}
